import { PartnerType } from "@/app/utils/partners.enum";
import { httpClient } from "../http/httpClient";

export type CreateTransactionRequest = {
  cpf: string;
  cliente: {
    nome: string;
    rg: string;
    rgEmissor: string;
    rgUfId: number;
    rgUf?: string;
    rgEmissao: string;
    sexo: number;
    estadoCivil: number;
    nacionalidadeId: number;
    naturalidadeUfId: number;
    naturalidadeCidadeId: number;
    grauInstrucaoId: number;
    nomeMae: string;
    nomeConjuge?: string;
    pep: boolean;
  };
  contatos: {
    contato: {
      email: string;
      telefone: string;
    };
    referencia?: {
      id: number;
      nome: string;
      telefone: string;
      grau: number;
    }[];
  };
  endereco: {
    cep: string;
    logradouro: string;
    numero: number;
    bairro: string;
    complemento?: string;
    cidadeId: number;
    cidade: string;
    uf: string;
  };
  bancario: {
    bancoId: string;
    agencia: string;
    digito: string;
    numero: string;
    conta: number;
    tipoConta: number;
  };
  operacao: {
    produtoId: number;
    vencimento: string;
    valorSolicitado: number;
    prazo: number;
    valorParcela: number;
    diaRecebimento?: number;
    tabelaJurosId?: number;
  };
};

export type CreateTransactionResponse = {
  _id: string;
  contract: string;
  value: number;
  status: string;
  type: PartnerType;
  createdAt: string;
  updatedAt: string;
};

export async function createTransaction(
  preTransactionId: string,
  payload: CreateTransactionRequest,
): Promise<CreateTransactionResponse> {
  const { data } = await httpClient
    .post<CreateTransactionResponse>(
      `/crefaz-clt/${preTransactionId}/transaction`,
      payload,
      { journey: PartnerType.CREFAZ_CLT },
    )
    .catch((error) => {
      throw error.response?.data ?? error;
    });

  return data;
}
